import { z } from 'zod';

export const riskSchema = z.object({
    areaOfRisk: z
        .array(
            z.enum([
                'Suicidal ideation',
                'Self harm',
                'Aggression towards others',
                'Homicidal ideation',
                'Inability to care for self',
                'Inability to care for others',
            ]),
        )
        .optional(),
    disposition: z
        .array(z.enum(['Intent to act', 'Means to act', 'Plan to act', 'None of the above']))
        .optional(),
    protectiveFactors: z
        .array(
            z.enum([
                'Cultural/religious beliefs',
                'Children in the home',
                'Employment',
                'Life satisfaction',
                'Meaningful hobbies',
                'Pets in the home',
                'Positive coping skills',
                'Positive past treatment experiences',
                'Reports motivation to live',
                'Strong social support',
                'Social responsibility',
                'Sufficient problem-solving skills',
                'Therapeutic rapport',
                'Willingness to use safety plan',
                'No protective factors present',
            ]),
        )
        .optional(),
    riskFactors: z
        .array(
            z.enum([
                'Current ideation',
                'Delusions/hallucinations',
                'Family history of suicide/suicide attempts',
                'History of attempts',
                'History of in-client treatment',
                'Hopelessness',
                'Impulsivity',
                'Interpersonal violence',
                'Lack of social support',
                'Means to act',
                'Recent loss',
                'Sexual or physical abuse exposure',
                'Substance use',
                'Sleep disturbance',
                'No risk factors present',
            ]),
        )
        .optional(),
    descriptionOfRisk: z.string().trim().optional(),
    safetyPlan: z.string().trim().optional(),
});
